import React, {Component} from 'react';
import {HEADER_HEIGHT} from "../../../constants";
import {Button} from "antd";

class NotColumnPage extends Component {

    render() {
        let mediaId = this.props.match.params.mediaId ? this.props.match.params.mediaId : '';
        return (
            <table width={"100%"} cellSpacing={0} cellPadding={0} border={0} style={{margin: 15, borderRadius: 5,height:document.body.clientHeight - HEADER_HEIGHT - 15 * 2, background:"#fff"}}>
                <tr><td align={"center"} valign={"middle"}>
                    无栏目无法新增文章，请点击<Button onClick={()=>{
                        window.location.hash = `#/mediaFusion/column/${mediaId}`;
                }} type={"link"} style={{padding:0}}>新增栏目</Button>，若已新增，请刷新页面试试。
                </td></tr>
            </table>
        );
    }
}

export default NotColumnPage;
